/** Define common colors, fonts, and other branding here */
const colors = {
  white: '#fff',
  black: '#000',

  /** Brand colors */
  briangerine: '#ff5100',
  blackish: '#231f20',
  merciless: '#373a36',
  assfault: '#4d5858',
  smokem: '#9eacaa',
  notWhite: '#edf0ef',
  kyleberry: '#682145',
  drizzleberry: '#ab0a3d',
  boogaloo: '#51fdf5',

  /** Data visualization colors */
  sealTears: '#26bfd0',
  shipwreck: '#007a8a',
  squidBlood: '#508fcc',
  deepBlue: '#003b71',
  neonSand: '#cdde00',
  seaweed: '#89dc65',
};

const charts = [
  colors.sealTears,
  colors.seaweed,
  colors.squidBlood,
  colors.deepBlue,
  colors.shipwreck,
  colors.neonSand,
];

/** These all need the same keys so each themed section can expect them */
const sectionThemes = {
  default: {
    primary: colors.briangerine,
    secondary: colors.blackish,
    highlight1: colors.blackish,
    highlight2: colors.blackish,
    highlight3: colors.blackish,
    highlight4: colors.blackish,
    charts: [
      colors.sealTears,
      colors.shipwreck,
      colors.squidBlood,
      colors.deepBlue,
      colors.neonSand,
      colors.seaweed,
    ],
  },
};

const fonts = {
  serif: 'serif',
  sansSerif: 'sans-serif',
  sofiapro: '"Sofia Pro", Helvetica, Arial, sans-serif',
  buntaro: '"Buntaro", Helvetica, Arial, sans-serif',
  buntaroItalic: '"Buntaro-Italic", Helvetica, Arial, sans-serif',
};

const sizes = {
  containerWidthSlim: '72rem',
  containerWidth: '110rem',
};

const breakpoints = {
  small: `screen and (max-width: 35em)`,
  smallMin: `screen and (min-width: 35em)`,
  medium: `screen and (max-width: 64em)`,
  large: `screen and (max-width: 96em)`,
  xlarge: `screen and (max-width: 110em)`,
  minHeight: `screen and (max-height: 37em)`,
};

const shadows = {
  primary: '0 0.2em 0.3em 0 rgba(0, 0, 0, .1)',
};

const animations = {
  ease: '.3s ease-in-out',
  smoothTransitionBezier: '.4s cubic-bezier(0.11, 0.59, 0.32, 0.9)',
};

const theme = {
  colors,
  charts,
  fonts,
  sizes,
  breakpoints,
  shadows,
  animations,
  /**
   * Assign each theme item so we can pick a primary color scheme per section.
   * We can also access each item per section individually in case we want to
   * do some overrides
   */
  ...sectionThemes,
};

export default theme;
